import { createBrowserClient } from '@supabase/ssr';
import { getSupabaseConfig } from '@/lib/config/environment';

export function createClient() {
  // Use environment-specific Supabase configuration
  const config = getSupabaseConfig();

  return createBrowserClient(config.url, config.anonKey, {
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    },
    global: {
      fetch: fetch.bind(globalThis)
    }
  });
}
